<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section epub:type="dedication" role="doc-dedication">
<p class="SP" id="ded"> </p>
<p class="SP"> </p>
<p class="Dedication-ded"><span aria-label="v" id="pg_v" role="doc-pagebreak">In memory of Stuart Hall (1932–2014), who demanded intellectual rigor and a fierce commitment to social justice</span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?d62bdcb0